import { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { dateUtils } from '~/routes/utils';
import { formatDataTest } from '~/utils';
import { DetailAction } from '~/components';
import { triggerEditPageClickedAnalytics } from '~/analytics/analytics.listener';

import styles from '../../section/Section.scss';

export class DateTimeDetails extends PureComponent {
  onClickHandler = () => {
    const {
      editPath,
      history,
      analyticsSectionType,
      matchParams: { appointmentId },
    } = this.props;
    triggerEditPageClickedAnalytics(analyticsSectionType);
    history.pushWithToken(`${appointmentId || ''}${editPath}`);
  };

  render() {
    const { title, selectedDateSlot, selectedTimeSlot, formatTimeSlot, children, showEditButton } =
      this.props;

    const date = dateUtils.getDateFromString(selectedDateSlot);
    const format = formatTimeSlot || dateUtils.getTimeSlotFormattedTime;

    return (
      <Fragment>
        <dt
          className={`${styles.Section__question_title} ${styles.Section__column}`}
          data-testid={formatDataTest(title, 'title')}
        >
          {title}
        </dt>
        <dd
          className={`${styles.Section__question_definition} ${styles.Section__column}`}
          data-testid={formatDataTest(title)}
        >
          <div className={classnames({ [styles.Section__editable_item]: showEditButton })}>
            <div>
              <p>{dateUtils.getTimeSlotFormattedDate(date)}</p>
              <time>{format(selectedTimeSlot.from, selectedTimeSlot.to)}</time>
              {children && children}
            </div>
            {showEditButton && (
              <DetailAction onClick={this.onClickHandler} extraClassName="EditableSectionItem" />
            )}
          </div>
        </dd>
      </Fragment>
    );
  }
}

DateTimeDetails.displayName = 'DateTimeDetails';

DateTimeDetails.propTypes = {
  title: PropTypes.string.isRequired,
  selectedDateSlot: PropTypes.string.isRequired,
  selectedTimeSlot: PropTypes.shape({}).isRequired,
  children: PropTypes.node,
  formatTimeSlot: PropTypes.func,
  showEditButton: PropTypes.bool,

  history: PropTypes.shape({}),
  matchParams: PropTypes.shape({}),
  analyticsSectionType: PropTypes.string,
  editPath: PropTypes.string,
};

DateTimeDetails.defaultProps = {
  formatTimeSlot: null,
  children: undefined,
  showEditButton: false,
  matchParams: {},
  history: {},
  analyticsSectionType: undefined,
  editPath: undefined,
};
